<template>
    <mdb-container fluid>

        <div class="row pt-5 pb-3">
            <div class="col-md-3 mx-auto mb-4">
                <div class="card pt-0 card-cascade narrower">

                    <div class="view view-cascade gradient-card-header mdb-color lighten-3">
                        <h5 class="mb-0 font-weight-bold">نوع گزارش:</h5>
                    </div>

                    <div class="card-body">
                        <ValidationObserver v-slot="{ invalid }">
                            <div class="mt-2">
                                <ValidationProvider v-slot="{ errors }" name="form.key" rules="required">
                                    <mdb-select :options="siteOptions" :error-messages="errors" placeholder="لیست سایت"
                                        label="انتخاب سایت " :required="true" @change="selectSite" />
                                </ValidationProvider>
                                <ValidationProvider v-slot="{ errors }" name="form.startDate" rules="required">
                                    <date-picker v-model="form.startDate" format="YYYY-MM-DD"
                                        display-format="jYYYY-jMM-jDD" />
                                </ValidationProvider>
                                <ValidationProvider v-slot="{ errors }" name="form.endDate" rules="required">
                                    <date-picker v-model="form.endDate" format="YYYY-MM-DD"
                                        display-format="jYYYY-jMM-jDD" />
                                </ValidationProvider>

                                <ValidationProvider v-slot="{ errors }" name="selectStatistcianType" rules="required">
                                    <ul class="striped list-unstyled pd-0" v-if="statistcianTypes != null">

                                        <li class="hover filter" v-for="(statistcianType, index) in statistcianTypes.sort((a,b) => a.Sort - b.Sort)"
                                            v-bind:key="index">
                                            <div class="form-check">
                                                <input class="form-check-input" type="radio" :id="'type_' + index"
                                                    :value="statistcianType.Type" :name="selectStatistcianType"
                                                    v-model="form.type" />
                                                <label class="form-check-label" v-text="statistcianType.Title"
                                                    :for="'type_' + index"> </label>
                                            </div>
                                        </li>

                                    </ul>
                                </ValidationProvider>
                            </div>

                            <mdb-btn gradient="purple" color="primary" class="mr-4" :disabled="invalid || posting"
                                @click="report" :loading="posting">گزارش</mdb-btn>

                        </ValidationObserver>
                    </div>

                </div>
            </div>

            <div class="col-md-8 mx-auto white z-depth-1 mb-4">
                <div class="row">
                    <div class="col-12 pt-5">
                        <div class="alert alert-info text-justify">
                            با احترام به کارفرمای گرامی، ما به دلایلی همچون جلوگیری از تقلب در بازدید، رفع مشکلات فیلترینگ، حل مشکلات مربوط به شبکه و اینترنت ملی و دیگر مسائل فنی، سامانه امار خود را با استفاده از الگوریتم‌های هوش مصنوعی بهبود می‌بخشیم. ارتقاء این سامانه نیازمند نظرات و پیشنهادات شما است، لذا با کمال میل منتظر تبادل نظر و انتقادات سازنده شما از طریق تیکت هستیم.
                            <br>
                            از همکاری شما سپاسگزاریم.
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12 pb-3">
                        <div id="chart-content" class="col-12" style="height:auto;background: #000">

                        </div>
                    </div>
                </div>
            </div>

        </div>

    </mdb-container>
</template>

<script>
import statisticianApi from "@/api/statisticianApi"
import VuePersianDatetimePicker from 'vue-persian-datetime-picker'

import { required } from "vee-validate/dist/rules";

import $ from 'jquery';

import Chart from 'chart.js';
import randomColor from 'randomcolor';

import {
    mdbContainer,
    mdbBtn,
    mdbInput,
    mdbTextarea,
    mdbFileInput,
    mdbSelect,
    mdbSwitch
} from "mdbvue";

export default {
    name: "company",
    components: {
        mdbContainer,
        mdbBtn,
        mdbInput,
        mdbTextarea,
        mdbFileInput,
        mdbSelect,
        mdbSwitch,
        datePicker: VuePersianDatetimePicker,
    },
    data() {
        return {
            statistcianTypes: [{ Type: "1", Title: "مرورگر بازدیدکنندگان",Sort :8 },
            { Type: "3", Title: "شهر بازدیدکنندگان",Sort :6 },
            { Type: "2", Title: "استان بازدیدکنندگان",Sort :5 },
            { Type: "4", Title: "کشور بازدیدکنندگان",Sort :4 },
            { Type: "5", Title: "دستگاه بازدیدکنندگان",Sort :7 },
            { Type: "6", Title: "ساعت بازدیدکنندگان",Sort :3 },
            { Type: "9", Title: "ماه های بازدیدکنندگان",Sort :1 },
            { Type: "10", Title: "سال های بازدیدکنندگان",Sort :2 },
            { Type: "7", Title: "برند دستگاه",Sort :9 },
            { Type: "8", Title: "مدل دستگاه",Sort :10 },
            { Type: "11", Title: "ارجا دهنده به ما",Sort :11 },
            { Type: "12", Title: "کمپین پلن",Sort :12 },
            { Type: "13", Title: "بازدید کمپین",Sort :13 },
            { Type: "14", Title: "خلاصه بازدید کمپین",Sort :14 },
            { Type: "15", Title: "بازدید رسانه",Sort :15 },
            { Type: "16", Title: "بازدید کل صفحه",Sort :16 },
            { Type: "17", Title: "بازدید صفحات فرود",Sort :17 },
            { Type: "18", Title: "مدت زمان مصرف در هر صفحه",Sort :18 },
            { Type: "19", Title: "روز های بازدیدکنندگان",Sort :0 }],
            selectStatistcianType: null,
            sites: [],
            form: {
                key: null,
                type: null,
                startDate: null,
                endDate: null
            },
            posting: false,
        };
    },
    validations: {
        form: {
            key: { required },
            type: { required },
            startDate: { required },
            endDate: { required }
        }
    },
    methods: {
        selectSite(value, text) {

            // console.log(value, text);
            this.form.key = value;
        },
        async report() {
            // console.log(this.form);
            let thisVue = this;

            let isUser = false;
            switch (parseInt(this.form.type)) {
                case 1:
                    {
                        thisVue.posting = true;
                        statisticianApi.getStatisticaian(
                            thisVue.form.key,
                            (isUser ? "activeUsers" : "sessions"),
                            "browser",
                            thisVue.form.startDate,
                            thisVue.form.endDate
                        ).then(
                            ({ data }) => {
                                thisVue.posting = false;

                                var sum = 0;
                                const ds = {
                                    labels: data.map(function (item) {
                                        sum += parseInt(item.Metrics[0]);
                                        return item.Dimensions[0] + "(" + item.Metrics[0] + ")";
                                    }),
                                    datasets: [{
                                        label: 'بازدیدکنندگان',
                                        data: data.map(function (item) {
                                            return item.Metrics[0];
                                        }),
                                        backgroundColor: randomColor({ count: data.length }), // استفاده از رنگ‌های تصادفی
                                        borderColor: 'rgba(255, 255, 255, 1)', // رنگ حاشیه
                                        borderWidth: 1
                                    }]
                                };
                                $('#chart-content').html('<canvas id="myChart" width="100%" height="400"></canvas>');
                                var ctx = document.getElementById('myChart')
                                    .getContext('2d');
                                var myChart = new Chart(ctx, {
                                    type: 'pie',
                                    data: ds,
                                    options: {
                                        responsive: true,
                                        plugins: {
                                            legend: {
                                                position: 'top',
                                            },
                                            title: {
                                                display: true,
                                                text: 'مرورگر بازدیدکنندگان ' + thisVue.form.startDate + ' تا ' + thisVue.form.endDate + ' جمع کل (' + sum + ')'
                                            }
                                        }
                                    },
                                });

                                thisVue.$toastr.s("گزارش", "گزارش با موفقیت ایجاد شد");
                            },
                            (r) => {
                                thisVue.posting = false;
                                thisVue.$toastr.e("گزارش", "خطایی اتفاق افتاد لطفا با مقادیر دیگری امتحان نمایید");
                            }
                        );
                        break;
                    }
                case 2:
                    {
                        thisVue.posting = true;
                        statisticianApi.getStatisticaian(
                            thisVue.form.key,
                            (isUser ? "activeUsers" : "sessions"),
                            "region",
                            thisVue.form.startDate,
                            thisVue.form.endDate
                        ).then(
                            ({ data }) => {
                                thisVue.posting = false;

                                const ds = {
                                    labels: data.map(function (item) {
                                        return item.Dimensions[0];
                                    }),
                                    datasets: [
                                        {
                                            label: 'بازدیدکنندگان',
                                            data: data.map(function (item) {
                                                return item.Metrics[0];
                                            }),
                                            backgroundColor: randomColor({ count: data.length }), // استفاده از رنگ‌های تصادفی
                                            borderColor: 'rgba(255, 255, 255, 1)', // رنگ حاشیه
                                            borderWidth: 1
                                        }
                                    ]
                                };
                                $('#chart-content').html('<canvas id="myChart" width="100%" height="400"></canvas>');
                                var ctx = document.getElementById('myChart')
                                    .getContext('2d');
                                var myChart = new Chart(ctx, {
                                    type: 'pie',
                                    data: ds,
                                    options: {
                                        responsive: true,
                                        plugins: {
                                            legend: {
                                                position: 'top',
                                            },
                                            title: {
                                                display: true,
                                                text: 'استان بازدیدکنندگان ' + thisVue.form.startDate + ' تا ' + thisVue.form.endDate
                                            }
                                        }
                                    },
                                });

                                thisVue.$toastr.s("گزارش", "گزارش با موفقیت ایجاد شد");
                            },
                            (r) => {
                                thisVue.posting = false;
                                thisVue.$toastr.e("گزارش", "خطایی اتفاق افتاد لطفا با مقادیر دیگری امتحان نمایید");
                            }
                        );
                        break;
                    }
                case 3:
                    {
                        thisVue.posting = true;
                        statisticianApi.getStatisticaian(
                            thisVue.form.key,
                            (isUser ? "activeUsers" : "sessions"),
                            "date;city",
                            thisVue.form.startDate,
                            thisVue.form.endDate
                        ).then(
                            ({ data }) => {
                                thisVue.posting = false;


                                let dateItems = {};
                                let cityItems = {};
                                data.forEach(function (item) {
                                    var key = item.Dimensions[0];
                                    if (key in dateItems) {
                                        var newItem = {};
                                        newItem[item.Dimensions[1]] = item.Metrics[0]
                                        dateItems[key].push(newItem);
                                    } else {
                                        var newItem = {};
                                        newItem[item.Dimensions[1]] = item.Metrics[0]
                                        dateItems[key] = [newItem]
                                    }

                                    key = item.Dimensions[1];
                                    if (key in cityItems) {
                                        cityItems[key][item.Dimensions[0]] = item.Metrics[0];
                                    } else {
                                        cityItems[key] = {};
                                        cityItems[key][item.Dimensions[0]] = item.Metrics[0]
                                    }
                                });
                                // console.log("dateItems", dateItems);
                                // console.log("cityItems", cityItems);
                                var labels = Object.keys(dateItems);
                                const ds = {
                                    labels: labels,
                                    datasets: Object.entries(cityItems).map(function (item, index) {
                                    return {
                                        label: item[0],
                                        data: labels.map(function (label) {
                                            if (label in cityItems[item[0]]) {
                                                return cityItems[item[0]][label];
                                            } else {
                                                return 0;
                                            }
                                        }),
                                        backgroundColor: 'rgba(' + (index * 50) + ', ' + (index * 100) + ', ' + (index * 150) + ', 0.2)',
                                        borderColor: 'rgba(' + (index * 50) + ', ' + (index * 100) + ', ' + (index * 150) + ', 1)',
                                        borderWidth: 1
                                    }
                                })
                                };
                                $('#chart-content').html('<canvas id="myChart" width="100%" height="400"></canvas>');
                                var ctx = document.getElementById('myChart')
                                    .getContext('2d');
                                var myChart = new Chart(ctx, {
                                    type: 'line',
                                    data: ds,
                                    options: {
                                        responsive: true,
                                        maintainAspectRatio: false,
                                        scales: {
                                            y: {
                                                stacked: true
                                            }
                                        },
                                        plugins: {
                                            filler: {
                                                propagate: false
                                            },
                                            'samples-filler-analyser': {
                                                target: 'chart-analyser'
                                            }
                                        },
                                        interaction: {
                                            intersect: false,
                                        },
                                    },
                                });

                                thisVue.$toastr.s("گزارش", "گزارش با موفقیت ایجاد شد");
                            },
                            (r) => {
                                thisVue.posting = false;
                                thisVue.$toastr.e("گزارش", "خطایی اتفاق افتاد لطفا با مقادیر دیگری امتحان نمایید");
                            }
                        );
                        break;
                    }
                case 4:
                    {
                        thisVue.posting = true;
                        statisticianApi.getStatisticaian(
                            thisVue.form.key,
                            (isUser ? "activeUsers" : "sessions"),
                            "country",
                            thisVue.form.startDate,
                            thisVue.form.endDate
                        ).then(
                            ({ data }) => {
                                thisVue.posting = false;
                                const ds = {
                                    labels: data.map(function (item) {
                                        return item.Dimensions[0];
                                    }),
                                    datasets: [
                                        {
                                            label: 'بازدیدکنندگان',
                                            data: data.map(function (item) {
                                                return item.Metrics[0];
                                            }),
                                            backgroundColor: randomColor({ count: data.length }), // استفاده از رنگ‌های تصادفی
                                            borderColor: 'rgba(255, 255, 255, 1)', // رنگ حاشیه
                                            borderWidth: 1
                                        }
                                    ]
                                };
                                $('#chart-content').html('<canvas id="myChart" width="100%" height="400"></canvas>');
                                var ctx = document.getElementById('myChart')
                                    .getContext('2d');
                                var myChart = new Chart(ctx, {
                                    type: 'pie',
                                    data: ds,
                                    options: {
                                        responsive: true,
                                        plugins: {
                                            legend: {
                                                position: 'top',
                                            },
                                            title: {
                                                display: true,
                                                text: 'کشور بازدیدکنندگان ' + thisVue.form.startDate + ' تا ' + thisVue.form.endDate
                                            }
                                        }
                                    },
                                });
                                thisVue.$toastr.s("گزارش", "گزارش با موفقیت ایجاد شد");
                            },
                            (r) => {
                                thisVue.posting = false;
                                thisVue.$toastr.e("گزارش", "خطایی اتفاق افتاد لطفا با مقادیر دیگری امتحان نمایید");
                            }
                        );
                        break;
                    }
                case 5:
                    {
                        thisVue.posting = true;
                        statisticianApi.getStatisticaian(
                            thisVue.form.key,
                            (isUser ? "activeUsers" : "sessions"),
                            "deviceCategory",
                            thisVue.form.startDate,
                            thisVue.form.endDate
                        ).then(
                            ({ data }) => {
                                thisVue.posting = false;

                                const ds = {
                                    labels: data.map(function (item) {
                                        return item.Dimensions[0];
                                    }),
                                    datasets: [
                                        {
                                            label: 'بازدیدکنندگان',
                                            data: data.map(function (item) {
                                                return item.Metrics[0];
                                            }),
                                            backgroundColor: randomColor({ count: data.length }), // استفاده از رنگ‌های تصادفی
                                            borderColor: 'rgba(255, 255, 255, 1)', // رنگ حاشیه
                                            borderWidth: 1
                                        }
                                    ]
                                };
                                $('#chart-content').html('<canvas id="myChart" width="100%" height="400"></canvas>');
                                var ctx = document.getElementById('myChart')
                                    .getContext('2d');
                                var myChart = new Chart(ctx, {
                                    type: 'pie',
                                    data: ds,
                                    options: {
                                        responsive: true,
                                        plugins: {
                                            legend: {
                                                position: 'top',
                                            },
                                            title: {
                                                display: true,
                                                text: 'دستگاه بازدیدکنندگان ' + thisVue.form.startDate + ' تا ' + thisVue.form.endDate
                                            }
                                        }
                                    },
                                });

                                thisVue.$toastr.s("گزارش", "گزارش با موفقیت ایجاد شد");
                            },
                            (r) => {
                                thisVue.posting = false;
                                thisVue.$toastr.e("گزارش", "خطایی اتفاق افتاد لطفا با مقادیر دیگری امتحان نمایید");
                            }
                        );
                        break;
                    }
                case 6:
                    {
                        thisVue.posting = true;
                        statisticianApi.getStatisticaian(
                            thisVue.form.key,
                            (isUser ? "activeUsers;userEngagementDuration;eventCount" : "sessions;userEngagementDuration;eventCount"),
                            "hour",
                            thisVue.form.startDate,
                            thisVue.form.endDate
                        ).then(
                            ({ data }) => {
                                thisVue.posting = false;

                                let houseItems = {};
                                data.forEach(function (item) {
                                    var key = item.Dimensions[0];
                                    houseItems[key] = item.Metrics
                                });
                                // console.log("houseItems", houseItems);

                                var labels = Object.keys(houseItems);
                                var ds_index = [0, 1, 2];
                                var ds_name = [(isUser ? 'بازدیدکنندگان' : 'سشن'), 'تعامل بازدیدکنندگان', 'اکشن بازدیدکنندگان'];
                                const ds = {
                                    labels: labels,
                                    datasets: ds_index.map(function (index) {
                                        return {
                                            label: ds_name[index],
                                            data: Object.entries(houseItems).map(function (item) {
                                                // console.log("index", index);
                                                // console.log("item", item);
                                                // console.log(item[1][index]);
                                                return item[1][index];
                                            }),
                                            fill: true,
                                            backgroundColor: randomColor(), // استفاده از رنگ تصادفی
                                            borderColor: 'rgba(255, 255, 255, 1)', // رنگ حاشیه
                                            borderWidth: 1
                                        }
                                    })
                                };
                                $('#chart-content').html('<canvas id="myChart" width="100%" height="400"></canvas>');
                                var ctx = document.getElementById('myChart')
                                    .getContext('2d');
                                var myChart = new Chart(ctx, {
                                    type: 'line',
                                    data: ds,
                                    options: {
                                        responsive: true,
                                        maintainAspectRatio: false,
                                        plugins: {
                                            title: {
                                                display: true,
                                                text: (ctx) => 'ساعت بازدید بازدیدکنندگان'
                                            },
                                            tooltip: {
                                                mode: 'index'
                                            },
                                        },
                                        interaction: {
                                            mode: 'nearest',
                                            axis: 'x',
                                            intersect: false
                                        },
                                        scales: {
                                            x: {
                                                title: {
                                                    display: true,
                                                    text: 'Month'
                                                }
                                            },
                                            y: {
                                                stacked: true,
                                                title: {
                                                    display: true,
                                                    text: 'Value'
                                                }
                                            }
                                        }
                                    }
                                });

                                thisVue.$toastr.s("گزارش", "گزارش با موفقیت ایجاد شد");
                            },
                            (r) => {
                                thisVue.posting = false;
                                thisVue.$toastr.e("گزارش", "خطایی اتفاق افتاد لطفا با مقادیر دیگری امتحان نمایید");
                            }
                        );
                        break;
                    }
                case 7:
                    {
                        thisVue.posting = true;
                        statisticianApi.getStatisticaian(
                            thisVue.form.key,
                            (isUser ? "activeUsers" : "sessions"),
                            "mobileDeviceBranding",
                            thisVue.form.startDate,
                            thisVue.form.endDate
                        ).then(
                            ({ data }) => {
                                thisVue.posting = false;


                                const ds = {
                                    labels: data.map(function (item) {
                                        return item.Dimensions[0];
                                    }),
                                    datasets: [
                                        {
                                            label: 'بازدیدکنندگان',
                                            data: data.map(function (item) {
                                                return item.Metrics[0];
                                            }),
                                            backgroundColor: randomColor({ count: data.length }), // استفاده از رنگ‌های تصادفی
                                            borderColor: 'rgba(255, 255, 255, 1)', // رنگ حاشیه
                                            borderWidth: 1
                                        }
                                    ]
                                };
                                $('#chart-content').html('<canvas id="myChart" width="100%" height="400"></canvas>');
                                var ctx = document.getElementById('myChart')
                                    .getContext('2d');
                                var myChart = new Chart(ctx, {
                                    type: 'pie',
                                    data: ds,
                                    options: {
                                        responsive: true,
                                        plugins: {
                                            legend: {
                                                position: 'top',
                                            },
                                            title: {
                                                display: true,
                                                text: 'مدل دستگاه ' + thisVue.form.startDate + ' تا ' + thisVue.form.endDate
                                            }
                                        }
                                    },
                                });

                                thisVue.$toastr.s("گزارش", "گزارش با موفقیت ایجاد شد");
                            },
                            (r) => {
                                thisVue.posting = false;
                                thisVue.$toastr.e("گزارش", "خطایی اتفاق افتاد لطفا با مقادیر دیگری امتحان نمایید");
                            }
                        );
                        break;
                    }
                case 8:
                    {
                        thisVue.posting = true;
                        statisticianApi.getStatisticaian(
                            thisVue.form.key,
                            (isUser ? "activeUsers" : "sessions"),
                            "MobileDeviceModel",
                            thisVue.form.startDate,
                            thisVue.form.endDate
                        ).then(
                            ({ data }) => {
                                thisVue.posting = false;


                                const ds = {
                                    labels: data.map(function (item) {
                                        return item.Dimensions[0];
                                    }),
                                    datasets: [
                                        {
                                            label: 'بازدیدکنندگان',
                                            data: data.map(function (item) {
                                                return item.Metrics[0];
                                            }),
                                            backgroundColor: randomColor({ count: data.length }), // استفاده از رنگ‌های تصادفی
                                            borderColor: 'rgba(255, 255, 255, 1)', // رنگ حاشیه
                                            borderWidth: 1
                                        }
                                    ]
                                };
                                $('#chart-content').html('<canvas id="myChart" width="100%" height="400"></canvas>');
                                var ctx = document.getElementById('myChart')
                                    .getContext('2d');
                                var myChart = new Chart(ctx, {
                                    type: 'pie',
                                    data: ds,
                                    options: {
                                        responsive: true,
                                        plugins: {
                                            legend: {
                                                position: 'top',
                                            },
                                            title: {
                                                display: true,
                                                text: 'مدل دستگاه ' + thisVue.form.startDate + ' تا ' + thisVue.form.endDate
                                            }
                                        }
                                    },
                                });

                                thisVue.$toastr.s("گزارش", "گزارش با موفقیت ایجاد شد");
                            },
                            (r) => {
                                thisVue.posting = false;
                                thisVue.$toastr.e("گزارش", "خطایی اتفاق افتاد لطفا با مقادیر دیگری امتحان نمایید");
                            }
                        );
                        break;
                    }
                case 9:
                    {
                        thisVue.posting = true;
                        statisticianApi.getStatisticaian(
                            thisVue.form.key,
                            (isUser ? "activeUsers;userEngagementDuration;eventCount" : "sessions;userEngagementDuration;eventCount"),
                            "yearMonth",
                            thisVue.form.startDate,
                            thisVue.form.endDate
                        ).then(
                            ({ data }) => {
                                thisVue.posting = false;

                                let houseItems = {};
                                data.forEach(function (item) {
                                    var key = item.Dimensions[0];
                                    houseItems[key] = item.Metrics
                                });
                                // console.log("houseItems", houseItems);
                                var labels = Object.keys(houseItems);
                                labels.sort(function (x1, x2) { return x1 - x2; });
                                var ds_index = [0, 1, 2];
                                var ds_name = [(isUser ? 'بازدیدکنندگان' : 'سشن'), 'تعامل بازدیدکنندگان', 'اکشن بازدیدکنندگان'];
                                const ds = {
                                    labels: labels,
                                    datasets: ds_index.map(function (index) {
                                        return {
                                            label: ds_name[index],
                                            data: Object.entries(houseItems).map(function (item) {
                                                // console.log("index", index);
                                                // console.log("item", item);
                                                // console.log(item[1][index]);
                                                return item[1][index];
                                            }),
                                            fill: true,
                                            backgroundColor: randomColor(), // استفاده از رنگ تصادفی
                                            borderColor: 'rgba(255, 255, 255, 1)', // رنگ حاشیه
                                            borderWidth: 1
                                        }
                                    })
                                };
                                $('#chart-content').html('<canvas id="myChart" width="100%" height="400"></canvas>');
                                var ctx = document.getElementById('myChart')
                                    .getContext('2d');
                                var myChart = new Chart(ctx, {
                                    type: 'line',
                                    data: ds,
                                    options: {
                                        responsive: true,
                                        maintainAspectRatio: false,
                                        plugins: {
                                            title: {
                                                display: true,
                                                text: (ctx) => 'ساعت بازدید بازدیدکنندگان'
                                            },
                                            tooltip: {
                                                mode: 'index'
                                            },
                                        },
                                        interaction: {
                                            mode: 'nearest',
                                            axis: 'x',
                                            intersect: false
                                        },
                                        scales: {
                                            x: {
                                                title: {
                                                    display: true,
                                                    text: 'Month'
                                                }
                                            },
                                            y: {
                                                stacked: true,
                                                title: {
                                                    display: true,
                                                    text: 'Value'
                                                }
                                            }
                                        }
                                    }
                                });

                                thisVue.$toastr.s("گزارش", "گزارش با موفقیت ایجاد شد");
                            },
                            (r) => {
                                thisVue.posting = false;
                                thisVue.$toastr.e("گزارش", "خطایی اتفاق افتاد لطفا با مقادیر دیگری امتحان نمایید");
                            }
                        );
                        break;
                    }
                case 10:
                    {
                        thisVue.posting = true;
                        statisticianApi.getStatisticaian(
                            thisVue.form.key,
                            (isUser ? "activeUsers;userEngagementDuration;eventCount" : "sessions;userEngagementDuration;eventCount"),
                            "year",
                            thisVue.form.startDate,
                            thisVue.form.endDate
                        ).then(
                            ({ data }) => {
                                thisVue.posting = false;
                                let houseItems = {};
                                data.forEach(function (item) {
                                    var key = item.Dimensions[0];
                                    houseItems[key] = item.Metrics
                                });
                                // console.log("houseItems", houseItems);

                                var labels = Object.keys(houseItems);
                                var ds_index = [0, 1, 2];
                                var ds_name = [(isUser ? 'بازدیدکنندگان' : 'سشن'), 'تعامل بازدیدکنندگان', 'اکشن بازدیدکنندگان'];
                                const ds = {
                                    labels: labels,
                                    datasets: ds_index.map(function (index) {
                                        return {
                                            label: ds_name[index],
                                            data: Object.entries(houseItems).map(function (item) {
                                                // console.log("index", index);
                                                // console.log("item", item);
                                                // console.log(item[1][index]);
                                                return item[1][index];
                                            }),
                                            fill: true,
                                            backgroundColor: randomColor(), // استفاده از رنگ تصادفی
                                            borderColor: 'rgba(255, 255, 255, 1)', // رنگ حاشیه
                                            borderWidth: 1
                                        }
                                    })
                                };
                                $('#chart-content').html('<canvas id="myChart" width="100%" height="400"></canvas>');
                                var ctx = document.getElementById('myChart')
                                    .getContext('2d');
                                var myChart = new Chart(ctx, {
                                    type: 'line',
                                    data: ds,
                                    options: {
                                        responsive: true,
                                        maintainAspectRatio: false,
                                        plugins: {
                                            title: {
                                                display: true,
                                                text: (ctx) => 'ساعت بازدید بازدیدکنندگان'
                                            },
                                            tooltip: {
                                                mode: 'index'
                                            },
                                        },
                                        interaction: {
                                            mode: 'nearest',
                                            axis: 'x',
                                            intersect: false
                                        },
                                        scales: {
                                            x: {
                                                title: {
                                                    display: true,
                                                    text: 'Month'
                                                }
                                            },
                                            y: {
                                                stacked: true,
                                                title: {
                                                    display: true,
                                                    text: 'Value'
                                                }
                                            }
                                        }
                                    }
                                });
                                thisVue.$toastr.s("گزارش", "گزارش با موفقیت ایجاد شد");
                            },
                            (r) => {
                                thisVue.posting = false;
                                thisVue.$toastr.e("گزارش", "خطایی اتفاق افتاد لطفا با مقادیر دیگری امتحان نمایید");
                            }
                        );
                        break;
                    }
                case 11:
                    {
                        thisVue.posting = true;
                        statisticianApi.getStatisticaian(
                            thisVue.form.key,
                            (isUser ? "activeUsers" : "sessions"),
                            "sessionSource",
                            thisVue.form.startDate,
                            thisVue.form.endDate
                        ).then(
                            ({ data }) => {
                                thisVue.posting = false;

                                const labels = data.map(function (item) {
                                    return item.Dimensions[0];
                                });

                                const ds = {
                                    labels: labels,
                                    datasets: [
                                        {
                                            label: '',
                                            data: data.map(function (item) {
                                                return item.Metrics[0];
                                            }),
                                            backgroundColor: randomColor({ count: data.length }), // استفاده از رنگ‌های تصادفی
                                            borderColor: 'rgba(255, 255, 255, 1)', // رنگ حاشیه
                                            borderWidth: 1
                                        }
                                    ]
                                };

                                $('#chart-content').html('<canvas id="myChart" width="100%" height="400"></canvas>');
                                var ctx = document.getElementById('myChart')
                                    .getContext('2d');
                                var myChart = new Chart(ctx, {
                                    type: 'pie',
                                    data: ds,
                                    options: {
                                        responsive: true,
                                        maintainAspectRatio: false,
                                        plugins: {
                                            legend: {
                                                position: 'top',
                                            },
                                            title: {
                                                display: true,
                                                text: 'ارجا دهنده'
                                            }
                                        }
                                    },
                                });
                                thisVue.$toastr.s("گزارش", "گزارش با موفقیت ایجاد شد");
                            },
                            (r) => {
                                thisVue.posting = false;
                                thisVue.$toastr.e("گزارش", "خطایی اتفاق افتاد لطفا با مقادیر دیگری امتحان نمایید");
                            }
                        );
                        break;
                    }
                case 12:
                    {
                        thisVue.posting = true;
                        statisticianApi.getStatisticaian(
                            thisVue.form.key,
                            (isUser ? "activeUsers" : "sessions"),
                            "sessionCampaignName",
                            thisVue.form.startDate,
                            thisVue.form.endDate
                        ).then(
                            ({ data }) => {
                                thisVue.posting = false;

                                const labels = data.map(function (item) {
                                    if (!item.Dimensions[0].startsWith('('))
                                        return item.Dimensions[0];
                                }).filter(function (item) { return item != undefined; });

                                const ds = {
                                    labels: labels,
                                    datasets:
                                        [
                                            {
                                                label: '',
                                                data: data.map(function (item) {
                                                    if (!item.Dimensions[0].startsWith('('))
                                                        return item.Metrics[0];
                                                    else
                                                        return undefined;
                                                }).filter(function (item) { return item != undefined; }),
                                                fill: true,
                                                backgroundColor: randomColor({ count: data.length }), // استفاده از رنگ تصادفی
                                                borderColor: 'rgba(255, 255, 255, 1)', // رنگ حاشیه
                                                borderWidth: 1
                                            }
                                        ]
                                };

                                // console.log("data", data);

                                $('#chart-content').html('<canvas id="myChart" width="100%" height="400"></canvas>');
                                var ctx = document.getElementById('myChart')
                                    .getContext('2d');
                                var myChart = new Chart(ctx, {
                                    type: 'pie',
                                    data: ds,
                                    options: {
                                        responsive: true,
                                        maintainAspectRatio: false,
                                        plugins: {
                                            legend: {
                                                position: 'top',
                                            },
                                            title: {
                                                display: true,
                                                text: 'ارجا دهنده'
                                            }
                                        }
                                    },
                                });
                                thisVue.$toastr.s("گزارش", "گزارش با موفقیت ایجاد شد");
                            },
                            (r) => {
                                thisVue.posting = false;
                                thisVue.$toastr.e("گزارش", "خطایی اتفاق افتاد لطفا با مقادیر دیگری امتحان نمایید");
                            }
                        );
                        break;
                    }
                case 13:
                    {
                        thisVue.posting = true;
                        statisticianApi.getStatisticaian(
                            thisVue.form.key,
                            (isUser ? "activeUsers" : "sessions"),
                            "date;sessionCampaignName",
                            thisVue.form.startDate,
                            thisVue.form.endDate
                        ).then(
                            ({ data }) => {
                                thisVue.posting = false;

                                let dateItems = {};
                                let nameItems = {};
                                data.forEach(function (item) {

                                    if (!item.Dimensions[1].startsWith('(')) {
                                        var key = item.Dimensions[0];
                                        if (key in dateItems) {
                                            var newItem = {};
                                            newItem[item.Dimensions[1]] = item.Metrics[0]
                                            dateItems[key].push(newItem);
                                        } else {
                                            var newItem = {};
                                            newItem[item.Dimensions[1]] = item.Metrics[0]
                                            dateItems[key] = [newItem]
                                        }

                                        key = item.Dimensions[1];
                                        if (key in nameItems) {
                                            nameItems[key][item.Dimensions[0]] = item.Metrics[0];
                                        } else {
                                            nameItems[key] = {};
                                            nameItems[key][item.Dimensions[0]] = item.Metrics[0]
                                        }
                                    }
                                });
                                //console.log("dateItems", dateItems);
                                //    console.log("nameItems", nameItems);
                                var labels = Object.keys(dateItems);
                                const ds = {
                                    labels: labels,
                                    datasets: Object.entries(nameItems).map(function (item) {
                                        return {
                                            label: item[0],
                                            data: labels.map(function (label) {
                                                //console.log(label);
                                                //console.log(item[1]);
                                                //console.log(nameItems[item[0]]);
                                                if (label in nameItems[item[0]]) {
                                                    return nameItems[item[0]][label];
                                                } else {
                                                    return 0;
                                                }
                                            }),
                                            backgroundColor: randomColor({ count: data.length }), // استفاده از رنگ‌های تصادفی
                                            borderColor: 'rgba(255, 255, 255, 1)', // رنگ حاشیه
                                            borderWidth: 1
                                        }
                                    })
                                };
                                $('#chart-content').html('<canvas id="myChart" width="100%" height="400"></canvas>');
                                var ctx = document.getElementById('myChart')
                                    .getContext('2d');
                                var myChart = new Chart(ctx, {
                                    type: 'line',
                                    data: ds,
                                    options: {
                                        responsive: true,
                                        maintainAspectRatio: false,
                                        scales: {
                                            y: {
                                                stacked: true
                                            }
                                        },
                                        plugins: {
                                            filler: {
                                                propagate: false
                                            },
                                            'samples-filler-analyser': {
                                                target: 'chart-analyser'
                                            }
                                        },
                                        interaction: {
                                            intersect: false,
                                        },
                                    },
                                });
                                thisVue.$toastr.s("گزارش", "گزارش با موفقیت ایجاد شد");
                            },
                            (r) => {
                                thisVue.posting = false;
                                thisVue.$toastr.e("گزارش", "خطایی اتفاق افتاد لطفا با مقادیر دیگری امتحان نمایید");
                            }
                        );
                        break;
                    }
                case 14:
                    {
                        thisVue.posting = true;
                        statisticianApi.getStatisticaian(
                            thisVue.form.key,
                            (isUser ? "activeUsers" : "sessions"),
                            "sessionMedium",
                            thisVue.form.startDate,
                            thisVue.form.endDate
                        ).then(
                            ({ data }) => {
                                thisVue.posting = false;

                                const labels = data.map(function (item) {
                                    if (!item.Dimensions[0].startsWith('('))
                                        return item.Dimensions[0];
                                }).filter(function (item) { return item != undefined; });

                                const ds = {
                                    labels: labels,
                                    datasets:
                                        [
                                            {
                                                label: '',
                                                data: data.map(function (item) {
                                                    if (!item.Dimensions[0].startsWith('('))
                                                        return item.Metrics[0];
                                                    else
                                                        return undefined;
                                                }).filter(function (item) { return item != undefined; }),
                                                fill: true,
                                                backgroundColor: randomColor({ count: data.length }), // استفاده از رنگ تصادفی
                                                borderColor: 'rgba(255, 255, 255, 1)', // رنگ حاشیه
                                                borderWidth: 1
                                            }
                                        ]
                                };

                                // console.log("data", data);

                                $('#chart-content').html('<canvas id="myChart" width="100%" height="400"></canvas>');
                                var ctx = document.getElementById('myChart')
                                    .getContext('2d');
                                var myChart = new Chart(ctx, {
                                    type: 'pie',
                                    data: ds,
                                    options: {
                                        responsive: true,
                                        maintainAspectRatio: false,
                                        plugins: {
                                            legend: {
                                                position: 'top',
                                            },
                                            title: {
                                                display: true,
                                                text: 'ارجا دهنده'
                                            }
                                        }
                                    },
                                });
                                thisVue.$toastr.s("گزارش", "گزارش با موفقیت ایجاد شد");
                            },
                            (r) => {
                                thisVue.posting = false;
                                thisVue.$toastr.e("گزارش", "خطایی اتفاق افتاد لطفا با مقادیر دیگری امتحان نمایید");
                            }
                        );
                        break;
                    }
                case 15:
                    {
                        thisVue.posting = true;
                        statisticianApi.getStatisticaian(
                            thisVue.form.key,
                            (isUser ? "activeUsers" : "sessions"),
                            "sessionSourceMedium",
                            thisVue.form.startDate,
                            thisVue.form.endDate
                        ).then(
                            ({ data }) => {
                                thisVue.posting = false;

                                const labels = data.map(function (item) {
                                    if (!item.Dimensions[0].startsWith('('))
                                        return item.Dimensions[0];
                                }).filter(function (item) { return item != undefined; });

                                const ds = {
                                    labels: labels,
                                    datasets:
                                        [
                                            {
                                                label: '',
                                                data: data.map(function (item) {
                                                    if (!item.Dimensions[0].startsWith('('))
                                                        return item.Metrics[0];
                                                    else
                                                        return undefined;
                                                }).filter(function (item) { return item != undefined; }),
                                                backgroundColor: randomColor({ count: data.length }), // استفاده از رنگ‌های تصادفی
                                                borderColor: 'rgba(255, 255, 255, 1)', // رنگ حاشیه
                                                borderWidth: 1
                                            }
                                        ]
                                };

                                // console.log("data", data);

                                $('#chart-content').html('<canvas id="myChart" width="100%" height="400"></canvas>');
                                var ctx = document.getElementById('myChart')
                                    .getContext('2d');
                                var myChart = new Chart(ctx, {
                                    type: 'pie',
                                    data: ds,
                                    options: {
                                        responsive: true,
                                        maintainAspectRatio: false,
                                        plugins: {
                                            legend: {
                                                position: 'top',
                                            },
                                            title: {
                                                display: true,
                                                text: 'ارجا دهنده'
                                            }
                                        }
                                    },
                                });
                                thisVue.$toastr.s("گزارش", "گزارش با موفقیت ایجاد شد");
                            },
                            (r) => {
                                thisVue.posting = false;
                                thisVue.$toastr.e("گزارش", "خطایی اتفاق افتاد لطفا با مقادیر دیگری امتحان نمایید");
                            }
                        );
                        break;
                    }
                case 16:
                    {
                        thisVue.posting = true;
                        statisticianApi.getStatisticaian(
                            thisVue.form.key,
                            (isUser ? "activeUsers" : "sessions"),
                            "fullPageUrl",
                            thisVue.form.startDate,
                            thisVue.form.endDate
                        ).then(
                            ({ data }) => {
                                thisVue.posting = false;
                                var csv = 'آدرس, تعداد بازدید\n';
                                data.forEach(function (item) {
                                    csv += item.Dimensions[0] + "," + item.Metrics[0] + "\n";
                                });
                                $('#chart-content').html('<a id="download-link-daynamic" class="btn btn-danger">دانلود</a>');
                                var hiddenElement = document.getElementById('download-link-daynamic');
                                hiddenElement.href = 'data:text/csv;charset=utf-8,%EF%BB%BF' + encodeURI(csv);
                                hiddenElement.target = '_blank';
                                hiddenElement.download = 'data.csv';
                                thisVue.$toastr.s("گزارش", "گزارش با موفقیت ایجاد شد");
                            },
                            (r) => {
                                thisVue.posting = false;
                                thisVue.$toastr.e("گزارش", "خطایی اتفاق افتاد لطفا با مقادیر دیگری امتحان نمایید");
                            }
                        );
                        break;
                    }
                case 17:
                    {
                        thisVue.posting = true;
                        statisticianApi.getStatisticaian(
                            thisVue.form.key,
                            (isUser ? "activeUsers" : "sessions"),
                            "landingPage",
                            thisVue.form.startDate,
                            thisVue.form.endDate
                        ).then(
                            ({ data }) => {
                                thisVue.posting = false;
                                var csv = 'آدرس, تعداد بازدید\n';
                                data.forEach(function (item) {
                                    csv += item.Dimensions[0] + "," + item.Metrics[0] + "\n";
                                });
                                $('#chart-content').html('<a id="download-link-daynamic" class="btn btn-danger">دانلود</a>');
                                var hiddenElement = document.getElementById('download-link-daynamic');
                                hiddenElement.href = 'data:text/csv;charset=utf-8,%EF%BB%BF' + encodeURI(csv);
                                hiddenElement.target = '_blank';
                                hiddenElement.download = 'data.csv';
                                thisVue.$toastr.s("گزارش", "گزارش با موفقیت ایجاد شد");
                            },
                            (r) => {
                                thisVue.posting = false;
                                thisVue.$toastr.e("گزارش", "خطایی اتفاق افتاد لطفا با مقادیر دیگری امتحان نمایید");
                            }
                        );
                        break;
                    }
                case 18:
                    {
                        thisVue.posting = true;
                        statisticianApi.getStatisticaian(
                            thisVue.form.key,
                            "userEngagementDuration",
                            "fullPageUrl",
                            thisVue.form.startDate,
                            thisVue.form.endDate
                        ).then(
                            ({ data }) => {
                                thisVue.posting = false;
                                var csv = 'آدرس, مدت زمان بازدید برحسب ثانیه\n';
                                data.forEach(function (item) {
                                    csv += item.Dimensions[0] + "," + item.Metrics[0] + "\n";
                                });
                                $('#chart-content').html('<a id="download-link-daynamic" class="btn btn-danger">دانلود</a>');
                                var hiddenElement = document.getElementById('download-link-daynamic');
                                hiddenElement.href = 'data:text/csv;charset=utf-8,%EF%BB%BF' + encodeURI(csv);
                                hiddenElement.target = '_blank';
                                hiddenElement.download = 'data.csv';
                                thisVue.$toastr.s("گزارش", "گزارش با موفقیت ایجاد شد");
                            },
                            (r) => {
                                thisVue.posting = false;
                                thisVue.$toastr.e("گزارش", "خطایی اتفاق افتاد لطفا با مقادیر دیگری امتحان نمایید");
                            }
                        );
                        break;
                    }
                case 19:
                {
                    thisVue.posting = true;
                    statisticianApi.getStatisticaian(
                        thisVue.form.key,
                        (isUser ? "activeUsers;userEngagementDuration;eventCount" : "sessions;userEngagementDuration;eventCount"),
                        "date",
                        thisVue.form.startDate,
                        thisVue.form.endDate
                    ).then(
                        ({ data }) => {
                            thisVue.posting = false;

                            let houseItems = {};
                            data.forEach(function (item) {
                                var key = item.Dimensions[0];
                                houseItems[key] = item.Metrics
                            });
                            // console.log("houseItems", houseItems);
                            var labels = Object.keys(houseItems);
                            labels.sort(function (x1, x2) { return x1 - x2; });
                            var ds_index = [0, 1, 2];
                            var ds_name = [(isUser ? 'بازدیدکنندگان' : 'سشن'), 'تعامل بازدیدکنندگان', 'اکشن بازدیدکنندگان'];
                            const ds = {
                                labels: labels,
                                datasets: ds_index.map(function (index) {
                                    return {
                                        label: ds_name[index],
                                        data: Object.entries(houseItems).map(function (item) {
                                            // console.log("index", index);
                                            // console.log("item", item);
                                            // console.log(item[1][index]);
                                            return item[1][index];
                                        }),
                                        fill: true,
                                        backgroundColor: randomColor(), // استفاده از رنگ تصادفی
                                        borderColor: 'rgba(255, 255, 255, 1)', // رنگ حاشیه
                                        borderWidth: 1
                                    }
                                })
                            };
                            $('#chart-content').html('<canvas id="myChart" width="100%" height="400"></canvas>');
                            var ctx = document.getElementById('myChart')
                                .getContext('2d');
                            var myChart = new Chart(ctx, {
                                type: 'line',
                                data: ds,
                                options: {
                                    responsive: true,
                                    maintainAspectRatio: false,
                                    plugins: {
                                        title: {
                                            display: true,
                                            text: (ctx) => 'ساعت بازدید بازدیدکنندگان'
                                        },
                                        tooltip: {
                                            mode: 'index'
                                        },
                                    },
                                    interaction: {
                                        mode: 'nearest',
                                        axis: 'x',
                                        intersect: false
                                    },
                                    scales: {
                                        x: {
                                            title: {
                                                display: true,
                                                text: 'Month'
                                            }
                                        },
                                        y: {
                                            stacked: true,
                                            title: {
                                                display: true,
                                                text: 'Value'
                                            }
                                        }
                                    }
                                }
                            });

                            thisVue.$toastr.s("گزارش", "گزارش با موفقیت ایجاد شد");
                        },
                        (r) => {
                            thisVue.posting = false;
                            thisVue.$toastr.e("گزارش", "خطایی اتفاق افتاد لطفا با مقادیر دیگری امتحان نمایید");
                        }
                    );
                    break;
                }
            }

        }
        // confirmCompany() {
        //   companyApi.updateCompany(this.company).then(
        //     ({ data }) => {
        //       if (data.Status === 1) {
        //         this.posting = false;
        //         // this.$store.state.userProfile.Avatar = data.Data;
        //         this.$toastr.s("پروفایل", "پروفایل با موفقیت بروز رسانی شد.");
        //       } else {
        //         this.message = data.Message;
        //         this.posting = false;
        //         this.$toastr.e("پروفایل", data.Message);
        //       }
        //     },
        //     (r) => {
        //       var message = r.response.data.errors;
        //       this.posting = false;
        //       this.message = null;

        //     }
        //   );
        // },
    },
    mounted() {
        statisticianApi.getSites().then(
            ({ data }) => {
                this.$store.state.sites = data;
                this.sites = this.$store.state.sites;
            },
            (r) => { }
        );
    },
    computed: {
        siteOptions: function () {
            var siteoptions = [];
            for (var i = 0; i < this.sites.length; i++) {
                siteoptions.push({ text: this.sites[i].Name, value: this.sites[i].Key, selected: false })
            }
            console.log('siteOptions : ' + siteoptions.length);
            return siteoptions;
        }

    },
};
</script>
